import React from "react";
import { Badge as BadgeAntd } from 'antd';
import { BadgeProps } from "antd/lib/badge";
import { RibbonProps } from "antd/lib/badge/Ribbon";

export interface BadgeInterface {
  children: React.ReactNode;
  badge?: BadgeProps | undefined;
  ribbon?: RibbonProps | undefined;
}

const Badge = (props: BadgeInterface) => {
  if (!props.badge && !props.ribbon) {
    return (
      <>
        {props.children}
      </>
    );
  }

  if (props.ribbon) {
    return (
      <BadgeAntd.Ribbon {...props.ribbon}>
        {props.children}
      </BadgeAntd.Ribbon>
    )
  }

  return (
    <BadgeAntd {...props.badge}>
      {props.children}
    </BadgeAntd>
  )
}

export default Badge;
